/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authSsoCallback } from '../../axios/authSsoCallback'
import type { AuthSsoCallbackError, AuthSsoCallbackRequest, AuthSsoCallbackResponse } from '../../types/AuthSsoCallback'

export const authSsoCallbackMutationKey = () => [{ url: '/auth/sso/callback' }] as const

export type AuthSsoCallbackMutationKey = ReturnType<typeof authSsoCallbackMutationKey>

export type AuthSsoCallbackVariables = {
	data: AuthSsoCallbackRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::ssoCallback */
export function useAuthSsoCallback<TContext = unknown>(
	options?: UseMutationOptions<
		AuthSsoCallbackResponse,
		AxiosError<AuthSsoCallbackError>,
		AuthSsoCallbackVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authSsoCallbackMutationKey(),
		mutationFn: ({ data }: AuthSsoCallbackVariables) => authSsoCallback(data, config).then(res => res.data),
		...options,
	})
}
